const errorHandler = (error, vm, info) => {
    if (error.response && error.response.status === 403) {
      // 处理403异常，例如提示用户无权限使用此功能
      console.log('无权限使用此功能');
      // 在此处可以使用Vue的弹窗组件显示提示信息
    } else {
      // 处理其他异常，例如提示用户请求出错
      console.log('请求出错');
    }
    console.log('请求出错1');
  };
  
  export default {
    install(Vue) {
      Vue.config.errorHandler = errorHandler;
      Vue.prototype.$throw = (error) => errorHandler(error, this);
    },
  };
  